import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(/* private authAervice: AuthService */) {}
  title = 'Wabtec-frontend';
}
